module.exports = __webpack_public_path__ + "static/media/revenue_.d82ddbf7.svg";